import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getSecretariatsAPI } from "../../services/api";
import defaultPhoto from "../../assets/imgs/default_photo.svg";

const SecretariatDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [secretariats, setSecretariats] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getSecretariatsAPI();
        setSecretariats(response.data);
      } catch (err) {
        console.error("Erro ao carregar as secretarias:", err);
        setError("Não foi possível carregar as secretarias.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (secretariats.length > 0) {
      const found = secretariats.find((s) => s.id === parseInt(id));
      setSelected(found || null);
    }
  }, [id, secretariats]);

  if (loading) return <div className="py-8 text-center text-gray-500">Carregando...</div>;
  if (error) return <div className="py-8 text-center text-red-500">{error}</div>;
  if (!selected) return <div className="py-8 text-center text-gray-500">Secretaria não encontrada.</div>;

  return (
    <div className="py-8 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row gap-8">

        {/* Sidebar */}
        <aside className="lg:w-72 flex-shrink-0">
          <h2 className="text-lg font-bold text-gray-700 mb-4 border-b pb-2">
            Secretarias Municipais
          </h2>
          <ul className="space-y-2">
            {secretariats.map((s) => (
              <li key={s.id}>
                <button
                  onClick={() => navigate(`/secretarias/${s.id}`)}
                  className={`w-full text-left px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                    s.id === selected.id
                      ? "bg-blue-600 text-white"
                      : "bg-gray-100 text-gray-700 hover:bg-blue-50 hover:text-blue-700"
                  }`}
                >
                  {s.name}
                </button>
              </li>
            ))}
          </ul>
        </aside>

        {/* Detail content */}
        <main className="flex-1 min-w-0">
          <button
            onClick={() => navigate("/secretarias")}
            className="mb-6 text-blue-500 hover:underline text-sm"
          >
            &larr; Voltar para Secretarias
          </button>

          {/* Header */}
          <div className="flex flex-col sm:flex-row items-start gap-6 bg-gray-50 rounded-2xl p-6 mb-8 shadow-sm">
            <img
              src={selected.photo || defaultPhoto}
              alt={selected.name}
              className="w-36 h-28 object-cover rounded-xl flex-shrink-0"
              onError={(e) => { e.target.src = defaultPhoto; e.target.onerror = null; }}
            />
            <div>
              <h1 className="text-2xl font-bold text-gray-800 mb-1">
                {selected.name}
              </h1>
              <p className="text-lg text-gray-600 mb-1">{selected.responsible}</p>
              <a
                href={`mailto:${selected.email}`}
                className="text-blue-500 hover:underline text-sm"
              >
                {selected.email}
              </a>
            </div>
          </div>

          {/* Sections */}
          <div className="space-y-4">
            {selected.sections.map((section) => (
              <details
                key={section.id}
                className="border rounded-2xl p-5"
                open
              >
                <summary className="text-lg font-semibold text-gray-800 cursor-pointer">
                  {section.title}
                </summary>
                <ul className="mt-4 space-y-2 text-gray-600 list-disc list-inside">
                  {section.content.map((item, index) => (
                    <li key={index} className="text-sm leading-relaxed">
                      {item}
                    </li>
                  ))}
                </ul>
              </details>
            ))}
          </div>
        </main>

      </div>
    </div>
  );
};

export default SecretariatDetail;
